export const LATIN_LETTERS_SPACE_DASH_REGEX = /[^A-Za-z\s'-]+/gim;
export const NOT_CYRILLIC_REGEX = /[\u0400-\u04FF]/gim;
export const NOT_DIGITS_REGEX = /\D/gim;

export const DATE_MATCH_REGEXP = /^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\d\d$/gim;

export const TESTING_SSN_MATCH_REGEX = /^(?!000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/gim;
export const PRODUCTION_SSN_MATCH_REGEX = /^(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/gim;

export const LAST_6_DIGITS_SSN_MATCH_REGEX = /^(?!00)\d{2}(?!0{4})\d{4}$/gim;

export const formatString = (regEx: RegExp) => (value: string) => value.replace(regEx, '');

export const unFormatBorrowerPhone = (phone: string) => {
  const reg = new RegExp(NOT_DIGITS_REGEX, 'g');
  const replaced = phone.replace(reg, '');

  if (!replaced) {
    return '';
  }

  return '+1' + phone.replace(reg, '');
};
